import React, { useState,useEffect } from "react";
import { Link,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderUserTitle from "../components/includes/HeaderUserTitle";
import Paging from "../../components/includes/Paging";
import { ChangeDateStringOnlyDate } from "../../components/common/Common";

const Question = () => {
  const mem_idx =  Number(localStorage.getItem("mem_idx"));
  const ch_idx = Number(localStorage.getItem('childrenIndex'));
  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);
  const navigate = useNavigate();
  //공지사항
  const [varQuestionList,setQuestionList] = useState([]);

  //페이지 조절 변수
  const [varTotalCount, setTotalCount] = useState(0);
  const [varPageSize] = useState(10);
  const [varPageNum, setPageNum] = useState(1);

  const GetQuestionList = async () => {
    const sendData = {quest_idx:mem_idx,ch_idx:ch_idx,pageNum:varPageNum,pageSize:varPageSize};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_question_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1){
        setTotalCount(datas.tcounts);
        const questionList = datas.results;
        setQuestionList(questionList);
        /* if(varPageNum === 1) setQuestionList(questionList);
        else setQuestionList(varQuestionList.concat(questionList)); */
      } 
    });
  }
  
  //최초실행부
  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});
    GetQuestionList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //console.log('pageNum',varPageNum);
    const showNum = (varPageNum-1)*varPageSize;
    if(varTotalCount > showNum) GetQuestionList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPageNum]); 
  
  const onGotoQuestionViewHandler = (e,board_idx) => {
    navigate(`/Parents/QuestionView/${board_idx}`);
  }

  return(
    <div className="vh-content normal-wrap">
      <HeaderUserTitle varPageTitle={'1:1 문의'} varBackString={'/Parents/MyPage'}/>
      <div className="vh-content-body">
        <div className="center-wrap">
          <div className="inq-wrap">
            <Link to={`/Parents/QuestionAdd`} className="btn-yes add">등록</Link>
            <div className="inq-con">
              {varQuestionList?.length===0?
                <div className="inq-box" style={{border:"1.2px solid #E6E6E6",fontSize:"14px"}}>
                  <div>문의 내역이 없습니다.</div>
                </div>
              :varQuestionList.map((questions,i)=>(
                <div className="inq-box" key={"questions_"+i} onClick={e=>onGotoQuestionViewHandler(e,questions.board_idx)}>
                  <div className="top-line">
                    <div className="date">{ChangeDateStringOnlyDate(questions.board_rdate)} 문의</div>
                    <div className={questions.board_status===1?"state":"state on"}>{questions.board_status===2?"답변완료":"답변대기"}</div>
                  </div>
                  <p className="inq-tit">{questions.board_title}</p>
                  <div className="inq-user-info">
                    <div><span>{questions.mem_name}</span>학부모</div>
                    ˙
                    <div><span>{questions.ch_name}</span>원아</div>
                  </div>
                </div>
              ))}
            </div>
            <Paging varTotalCount={varTotalCount} varPageSize={varPageSize} varPageNum={varPageNum} setPageNum={setPageNum} />
          </div>
        </div>
      </div>
    </div>
  );
}
export default Question;